function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import { useContext } from 'react';
import * as React from 'react';

import { ThemeContext } from 'styled-components';

import { SonntagButtonV2 } from "../SonntagButtonV2";











export const CtaButton = ({
  className,
  size,
  fullWidth,
  iconPath,
  iconSvgCode,
  children,
  disabled,
  ...props }) =>
{
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/(
    React.createElement(SonntagButtonV2, _extends({
      className: className,
      iconPath: iconPath,
      iconSvgCode: iconSvgCode,
      disabled: disabled,
      fullWidth: fullWidth,
      size: size,
      solid: true,
      accentColor: theme.colors.Color1 },
    props),

    children));


};